import * as React from "react";

const Grid: React.FC = () => {
    return (
        <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Icon/Grid</title>
            <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Product-Listing_Default" transform="translate(-1125.000000, -230.000000)" fill="#33333A">
                    <path d="M1131,238 L1131,245 L1125,245 L1125,238 L1131,238 Z M1139,238 L1139,245 L1133,245 L1133,238 L1139,238 Z M1131,230 L1131,237 L1125,237 L1125,230 L1131,230 Z M1139,230 L1139,237 L1133,237 L1133,230 L1139,230 Z" id="Icon/Grid"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Grid);
